import { CDPFieldsEnums } from '@/modules/CDP/shared/contacts/domain/enums/CDPFieldsEnums'

export const PeopleStore = {
  namespaced: true,
  state: {
    tableFields: [CDPFieldsEnums.EMAIL, CDPFieldsEnums.PHONE, CDPFieldsEnums.CREATED_AT],
    orderedFields: [
      CDPFieldsEnums.STATUS, CDPFieldsEnums.MIDNAME, CDPFieldsEnums.REGISTER_CHANNEL, CDPFieldsEnums.ROLES, CDPFieldsEnums.ALIAS, CDPFieldsEnums.BIRTH_DATE, CDPFieldsEnums.CATEGORY,
      CDPFieldsEnums.GENDER, CDPFieldsEnums.DOCUMENT_TYPE, CDPFieldsEnums.DOCUMENT, CDPFieldsEnums.NATIONALITY, CDPFieldsEnums.COUNTRY, CDPFieldsEnums.CITY, CDPFieldsEnums.ZONE,
      CDPFieldsEnums.LANGUAGE, CDPFieldsEnums.RESPONSIBLE
    ]
  },
  mutations: {
    SET_TABLE_FIELDS (state: any, fields: string[]) {
      state.tableFields = fields
    },
    SET_ORDERED_FIELDS (state: any, fields: string[]) {
      state.orderedFields = fields
    }
  },
  actions: {
    setTableFields ({ commit }, fields: string[]) {
      commit('SET_TABLE_FIELDS', fields)
    },
    setOrderedFields ({ commit }, fields: string[]) {
      commit('SET_ORDERED_FIELDS', fields)
    }
  }
}
